module.exports = __webpack_public_path__ + "img/prize_4.0acce84b.gif";